import React from 'react';
import { translate } from 'react-i18next';
import PropTypes from 'prop-types';

import MenuItem from '../../MenuItem';

import * as Routes from '../../../../Routes/constants';

function PublicNavigation({ t }) {
  return (
    <React.Fragment>
      <MenuItem exact to={Routes.LOGIN} label={t('menu.login')} />
      <MenuItem exact to={Routes.REGISTER} label={t('menu.register')} />
    </React.Fragment>
  );
}

PublicNavigation.propTypes = {
  t: PropTypes.func.isRequired,
};

export default translate()(PublicNavigation);



// WEBPACK FOOTER //
// ./src/app/components/NavigationBar/components/NavigationMenu/menus/PublicNavigation.js